import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { getSeoForPath, absoluteUrl } from "./getSeoForPath";
import {
  SITE_NAME,
  DEFAULT_DESCRIPTION,
  OG_IMAGE,
} from "./siteConfig";

export default function SeoHead() {
  const { pathname } = useLocation();
  const seo = getSeoForPath(pathname);
  const canonical = absoluteUrl(seo.canonicalPath ?? pathname);

  return (
    <Helmet prioritizeSeoTags>
      <html lang="bg" />
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="robots" content={seo.robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="bg_BG" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta
        property="og:image:alt"
        content={`${SITE_NAME} — Монтана`}
      />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      <meta name="twitter:image:alt" content={`${SITE_NAME} — Монтана`} />
    </Helmet>
  );
}

/* Re-export for rare use in deeply dynamic pages */
export { DEFAULT_DESCRIPTION, SITE_NAME, OG_IMAGE };
